export { default, default as RemovableTag, SimpleTag } from './tag';
export type { RemovableTagProps, SimpleTagProps } from './tag';

export type { AppearanceType, MigrationFallback, TagColor } from './types';

// Export new visual refresh components
export { AvatarTag } from './tag-new';
export type {
	AvatarTagProps,
	AvatarRenderProps,
	TypesOfAvatars,
	NewTagColor,
	TagNewProps,
} from './tag-new';
